import { render, staticRenderFns } from "./GBoothSettingForm.vue?vue&type=template&id=b18fa85a&scoped=true&"
import script from "./GBoothSettingForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothSettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothSettingForm.vue?vue&type=style&index=0&id=b18fa85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18fa85a",
  null
  
)

export default component.exports